export default __webpack_public_path__ + "static/media/Allianz_negativo.b730444c.svg";